import { Button, Table, Badge, Pagination, Empty, Spin } from 'antd';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Header from './Header';
import ReportsFilter from './ReportsFilter';
import TotalPanel from './TotalPanel';
import { renderTableColumns } from '../../common/renderColumns';
import { CONST_PATH_LEVEL_MAPPING, CONST_SUMMARY_PATH_LEVEL_MAPPING } from '../../common/reportsConstants'
import { convertToFooterColumns, formatFormdata, renderMergedColumn, returnFloat, isCanadaSeller } from './formatData';
import _ from 'lodash';
import { CONST_PAGINATION_TEN, REPORTS_HEADER_TITLE_SUMMARY, SIA_DASHBOARD_CONDITION_DATA_KEY, SIA_REPORTS_KEY_VALUE, SIA_TERRITORY_DATA_KEY } from '../../common/constants';
import { useFetchSummaryData, useExportSummaryReport, useResetReportsData, 
  useFetchOrdersReportByChannelType, useExportOrdersReportByChannelType,
  useFetchScInActionData ,useExportScInActionReportData,useFetchSummaryCustomerData,useFetchSummaryOrderData,
  useFetchSummaryDataFromChannelType,useFetchOrdersData,useExportOrdersReport,
  useFetchScInActionCustomerData,useFetchScInActionOrderData,useExportSummaryCustomerReport,useExportSummaryOrderReport,
  useExportScInActionCustomerReport,useExportScInActionOrderReport, useFetchOrderDetailReport, useExportOrderDetailReport,
  useFetchSummaryDataByRegion, useExportSummaryRegionReport,
  useFetchOosReportBySite,useFetchOosReportByCategory,useFetchOosReportByOrderNumber,useExportOosReportBySite,useExportOosReportByCategory,useExportOosReportByOrderNumber, 
  useExportOosAccountAccountType, useExportOosAccountCustomer, useExportOosAccountOrder,
  useFetchOosAccountAccountType, useFetchOosAccountCustomer, useFetchOosAccountOrder,
  useFetchSummaryDataBySite,
  useExportSummaryDataBySite,
} from '../reports/redux/hooks';
import TableFooter from '../reports/TableFooter';
import { downloadFile } from '../../common/downloadReportFunc';
import { ExportAlertModal } from '../common';
import ExportButton from './ExportButton';
import { useSaveReportsKeyValue } from './redux/hooks';
import { datadogRum } from '@datadog/browser-rum';
import { resetReportsCustomerLevelData } from '../reports/redux/resetReportsCustomerLevelData';
import { resetReportsDataOrders } from '../reports/redux/resetReportsDataOrders';
import { useTranslation } from "react-i18next";


export default function CommonPage(props) {
  const { t } = useTranslation();
  const {
    dashboardConditionData,
    territoryData,
    reportsValues,
    fetchScInActionDataPending,
    fetchSummaryDataPending,
    fetchOrdersReportByChannelTypePending,
    exportSummaryReportPending,
    exportOrdersReportByChannelTypePending,
    exportScInActionReportDataPending,
    reportsData,
    reportsTotals,
    summary,
    reportsCustomerData,
    reportsCustomerTotals,
    customerSummary,
    reportsOrderData,
    reportsOrderTotals,
    orderSummary,
    reportsOrderDetailData,
    reportsOrderDetailTotals,
    orderDetailSummary,
    fetchSummaryCustomerDataPending,
    fetchSummaryOrderDataPending,
    exportSummaryCustomerReportPending,
    exportSummaryOrderReportPending,
    fetchScInActionCustomerDataPending,
    fetchScInActionOrderDataPending,
    exportScInActionCustomerReportPending,
    exportScInActionOrderReportPending,
    fetchSummaryDataFromChannelTypePending,
    fetchOrdersDataPending,
    exportOrdersReportPending,
    fetchOrderDetailReportPending,
    exportOrderDetailReportPending,
    reportsRegionData,
    reportsRegionTotals,
    regionSummary,
    siteUser,
    fetchSummaryDataByRegionPending,
    exportSummaryRegionReportPending,

    fetchOosReportBySitePending,
    fetchOosReportByCategoryPending,
    fetchOosReportByOrderNumberPending,
    exportOosReportBySitePending,
    exportOosReportByCategoryPending,
    exportOosReportByOrderNumberPending,
    fetchOosAccountAccountTypePending,
    fetchOosAccountCustomerPending,
    fetchOosAccountOrderPending,
    exportOosAccountAccountTypePending,
    exportOosAccountCustomerPending,
    exportOosAccountOrderPending,
    reportsSiteData,
    reportsSiteTotals,
    siteSummary,
    fetchSummaryDataBySitePending,
    exportSummaryDataBySitePending,
  } = useSelector(state => ({
    dashboardConditionData: state.dashboard.dashboardConditionData,
    territoryData: state.dashboard.territoryData,
    reportsValues: state.reportsNew.reportsKeyValue,
    fetchScInActionDataPending:state.reports.fetchScInActionDataPending,
    fetchSummaryDataPending: state.reports.fetchSummaryDataPending,
    fetchOrdersReportByChannelTypePending: state.reports.fetchOrdersReportByChannelTypePending,
    exportSummaryReportPending: state.reports.exportSummaryReportPending,
    exportOrdersReportByChannelTypePending: state.reports.exportOrdersReportByChannelTypePending,
    exportScInActionReportDataPending: state.reports.exportScInActionReportDataPending,
    reportsData: state.reports.reportsData,
    reportsTotals: state.reports.reportsTotals,
    summary: state.reports.summary,
    reportsCustomerData: state.reports.reportsCustomerData,
    reportsCustomerTotals: state.reports.reportsCustomerTotals,
    customerSummary: state.reports.customerSummary,
    reportsOrderData: state.reports.reportsOrderData,
    reportsOrderTotals: state.reports.reportsOrderTotals,
    orderSummary: state.reports.orderSummary,
    reportsOrderDetailData: state.reports.reportsOrderDetailData,
    reportsOrderDetailTotals: state.reports.reportsOrderDetailTotals,
    orderDetailSummary: state.reports.orderDetailSummary,
    fetchSummaryCustomerDataPending: state.reports.fetchSummaryCustomerDataPending,
    fetchSummaryOrderDataPending: state.reports.fetchSummaryOrderDataPending,
    exportSummaryCustomerReportPending: state.reports.exportSummaryCustomerReportPending,
    exportSummaryOrderReportPending: state.reports.exportSummaryOrderReportPending,
    fetchScInActionCustomerDataPending: state.reports.fetchScInActionCustomerDataPending,
    fetchScInActionOrderDataPending: state.reports.fetchScInActionOrderDataPending,
    exportScInActionCustomerReportPending: state.reports.exportScInActionCustomerReportPending,
    exportScInActionOrderReportPending: state.reports.exportScInActionOrderReportPending,
    fetchSummaryDataFromChannelTypePending: state.reports.fetchSummaryDataFromChannelTypePending,
    fetchOrdersDataPending: state.reports.fetchOrdersDataPending,
    exportOrdersReportPending: state.reports. exportOrdersReportPending,
    fetchOrderDetailReportPending: state.reports.fetchOrderDetailReportPending,
    exportOrderDetailReportPending: state.reports.exportOrderDetailReportPending,
    reportsRegionData: state.reports.reportsRegionData,
    reportsRegionTotals: state.reports.reportsRegionTotals,
    regionSummary: state.reports.regionSummary,
    siteUser: state.dashboard.isSiteUser,
    fetchSummaryDataByRegionPending: state.reports.fetchSummaryDataByRegionPending,
    exportSummaryRegionReportPending: state.reports.exportSummaryRegionReportPending,
    fetchOosReportBySitePending: state.reports.fetchOosReportBySitePending,
    fetchOosReportByCategoryPending: state.reports.fetchOosReportByCategoryPending,
    fetchOosReportByOrderNumberPending: state.reports.fetchOosReportByOrderNumberPending,
    exportOosReportBySitePending: state.reports.exportOosReportBySitePending,
    exportOosReportByCategoryPending: state.reports.exportOosReportByCategoryPending,
    exportOosReportByOrderNumberPending: state.reports.exportOosReportByOrderNumberPending,
    fetchOosAccountAccountTypePending: state.reports.fetchOosAccountAccountTypePending,
    fetchOosAccountCustomerPending: state.reports.fetchOosAccountCustomerPending,
    fetchOosAccountOrderPending: state.reports.fetchOosAccountOrderPending,
    exportOosAccountAccountTypePending: state.reports.exportOosAccountAccountTypePending,
    exportOosAccountCustomerPending: state.reports.exportOosAccountCustomerPending,
    exportOosAccountOrderPending: state.reports.exportOosAccountOrderPending,
    reportsSiteData: state.reports.reportsSiteData,
    reportsSiteTotals: state.reports.reportsSiteTotals,
    siteSummary: state.reports.siteSummary,
    fetchSummaryDataBySitePending: state.reports.fetchSummaryDataBySitePending,
    exportSummaryDataBySitePending: state.reports.exportSummaryDataBySitePending,
  }));
  const {tabKey,columnsProp,level}=props;
  const { fetchSummaryData } = useFetchSummaryData();
  const { resetReportsData } = useResetReportsData();
  const { saveReportsKeyValue } = useSaveReportsKeyValue();
  const {fetchOrdersReportByChannelType} = useFetchOrdersReportByChannelType();
  const {exportOrdersReportByChannelType} = useExportOrdersReportByChannelType();
  const {fetchScInActionData} = useFetchScInActionData();
  const { fetchSummaryCustomerData } = useFetchSummaryCustomerData();
  const { fetchSummaryOrderData } = useFetchSummaryOrderData();
  const { fetchSummaryDataFromChannelType } = useFetchSummaryDataFromChannelType();
  const { fetchOrdersData } = useFetchOrdersData();
  const { exportOrdersReport } = useExportOrdersReport();
  const { fetchScInActionCustomerData } = useFetchScInActionCustomerData();
  const { fetchScInActionOrderData } = useFetchScInActionOrderData();
  const { exportSummaryReport } = useExportSummaryReport();
  const { exportSummaryCustomerReport } = useExportSummaryCustomerReport();
  const { exportSummaryOrderReport } = useExportSummaryOrderReport();
  const { exportScInActionReportData } = useExportScInActionReportData();
  const { exportScInActionCustomerReport } = useExportScInActionCustomerReport();
  const { exportScInActionOrderReport } = useExportScInActionOrderReport();
  const { fetchOrderDetailReport } = useFetchOrderDetailReport();
  const { exportOrderDetailReport } = useExportOrderDetailReport();
  const { fetchSummaryDataByRegion } = useFetchSummaryDataByRegion();
  const { exportSummaryRegionReport} = useExportSummaryRegionReport();
  const { fetchOosReportBySite } = useFetchOosReportBySite();
  const { fetchOosReportByCategory } = useFetchOosReportByCategory();
  const { fetchOosReportByOrderNumber } = useFetchOosReportByOrderNumber();
  const { exportOosReportBySite } = useExportOosReportBySite();
  const { exportOosReportByCategory } = useExportOosReportByCategory();
  const { exportOosReportByOrderNumber } = useExportOosReportByOrderNumber();
  const { fetchOosAccountAccountType } = useFetchOosAccountAccountType();
  const { fetchOosAccountCustomer } = useFetchOosAccountCustomer();
  const { fetchOosAccountOrder } = useFetchOosAccountOrder();
  const { exportOosAccountAccountType } = useExportOosAccountAccountType();
  const { exportOosAccountCustomer } = useExportOosAccountCustomer();
  const { exportOosAccountOrder } = useExportOosAccountOrder ();
  const { fetchSummaryDataBySite } = useFetchSummaryDataBySite ();
  const { exportSummaryDataBySite } = useExportSummaryDataBySite ();
  const [pagination, setPagination] = useState(CONST_PAGINATION_TEN);
  const [sorting, setSorting] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [isOpenPop, setIsOpenPop] = useState(false);
  //COT-9353: SIA+ Screen refresh issue.
  const [isSiteUser,setIsSiteUser] = useState(siteUser || JSON.parse(sessionStorage.getItem(SIA_TERRITORY_DATA_KEY))?.isSiteUser);
  const [showFilter, setShowFilter] = useState((tabKey !== 'Summary' && level === 1) || (tabKey === 'Summary' && !isSiteUser && level === 0) || (tabKey === 'Summary' && isSiteUser && level === 2));
  const history = useHistory();
  const isOpenPopFun = () => {
    setIsOpenPop(true)
  };
  const isClosePopFun = () =>{
    setIsOpenPop(false)
  }
  //COT-9353: SIA+ Screen refresh issue.
  let conditionData = dashboardConditionData;
  let reportsKeyValue = reportsValues;
  if(!_.isEmpty(sessionStorage.getItem(SIA_DASHBOARD_CONDITION_DATA_KEY))){
    conditionData = JSON.parse(sessionStorage.getItem(SIA_DASHBOARD_CONDITION_DATA_KEY));
  }
  if(!_.isEmpty(sessionStorage.getItem(SIA_REPORTS_KEY_VALUE))){
    reportsKeyValue = JSON.parse(sessionStorage.getItem(SIA_REPORTS_KEY_VALUE));
  }
  let condition = formatFormdata(conditionData, territoryData ? territoryData : JSON.parse(sessionStorage.getItem(SIA_TERRITORY_DATA_KEY))?.territoryData);
  useEffect(() => {
    setPagination(CONST_PAGINATION_TEN);
    // setSorting();
    setShowAlert(false);
    resetReportsData();
  }, [dashboardConditionData]); // eslint-disable-line
  useEffect(() => {
    if (!_.isEmpty(dashboardConditionData) || !_.isEmpty(sessionStorage.getItem(SIA_DASHBOARD_CONDITION_DATA_KEY))) { //COT-9353: SIA+ Screen refresh issue.
      fetchOrderReportList(pagination, sorting);
    }
  }, [pagination, sorting, dashboardConditionData]); // eslint-disable-line
  /**
   *  footer will scroll when horizontal scrolled table
   */
  useEffect(() => {
    const parentScroll = document.querySelector('.report-new-table .ant-table-body');
    const footerScroll = document.querySelector('.ant-table-footer .ant-table-body');
    if (parentScroll && footerScroll) {
      const scale = (parentScroll.scrollWidth - parentScroll.clientWidth) / (footerScroll.scrollWidth - footerScroll.clientWidth);
      let flag = 0;

      parentScroll.addEventListener('scroll', () => {
        if (flag !== 1) return;
        footerScroll.scrollLeft = parentScroll.scrollLeft / scale;
      });
      footerScroll.addEventListener('scroll', () => {
        if (flag !== 2) return;
        parentScroll.scrollLeft = footerScroll.scrollLeft * scale;
      });
      parentScroll.addEventListener('mouseover', () => {
        flag = 1;
      }, true);
      footerScroll.addEventListener('mouseover', () => {
        flag = 2;
      }, true);
      return () => {
        parentScroll.removeEventListener('scroll', () => {
          if (flag !== 1) return;
          footerScroll.scrollLeft = parentScroll.scrollLeft / scale;
        });
        footerScroll.removeEventListener('scroll', () => {
          if (flag !== 2) return;
          parentScroll.scrollLeft = footerScroll.scrollLeft * scale;
        });
        parentScroll.removeEventListener('mouseover', () => {
          flag = 1;
        }, true);
        footerScroll.removeEventListener('mouseover', () => {
          flag = 2;
        }, true);
      }
    }
  }); // eslint-disable-line
  let dataSource = [];
  let backTo='';
  let totals= 0;
  let title = '';
  let footerData = [];
  
  if(tabKey === 'Summary'){
    let regionTitle = `${t(tabKey)} ${t('forRegion')}`;
    let accountTypeTitle = `${t(tabKey)} ${t('forAccountType')}`;
    switch (level) {
      case 0:
        title = t(REPORTS_HEADER_TITLE_SUMMARY);
        dataSource = reportsRegionData;
        totals = reportsRegionTotals;
        footerData = JSON.parse(JSON.stringify(regionSummary));
        // Transform individual row data: map totalScNetCost to estimatedScgp field
        if (dataSource && Array.isArray(dataSource)) {
          dataSource.forEach(row => {
            // For individual rows, use totalScNetCost value as estimatedScgp
            if (row.totalScNetCost !== undefined) {
              row.estimatedScgp = row.totalScNetCost;
            }
          });
        }
        backTo='';
        break;
      case 1:
        if(!isSiteUser){
          title = `${regionTitle} - ${reportsKeyValue.region}`;
          backTo='/summary';
          condition = {
            ...condition,
            sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
            regions: [reportsKeyValue.region],
          }
        }else{
          title = t(REPORTS_HEADER_TITLE_SUMMARY);
          backTo='';
        }
        dataSource = reportsSiteData;
        totals = reportsSiteTotals;
        footerData = JSON.parse(JSON.stringify(siteSummary));
        // Transform individual site data: map totalScNetCost to estimatedScgp field
        if (dataSource && Array.isArray(dataSource)) {
          dataSource.forEach(row => {
            // For individual sites, use totalScNetCost value as estimatedScgp
            if (row.totalScNetCost !== undefined) {
              row.estimatedScgp = row.totalScNetCost;
            }
          });
        }
        break;
      case 2:
        if(!isSiteUser){
          title = `${regionTitle} - ${reportsKeyValue.region} - ${reportsKeyValue.opco}`;
          backTo='/summary/site-sales';
          condition = {
            ...condition,
            sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
            regions: [reportsKeyValue.region],
          }
        }else{
          title = t(REPORTS_HEADER_TITLE_SUMMARY);
          backTo='';
        }
        dataSource = reportsData;
        totals = reportsTotals;
        footerData = JSON.parse(JSON.stringify(summary));
        // Add conditional transformation for case 2 (account type level)
        if (dataSource && Array.isArray(dataSource)) {
          dataSource.forEach(row => {
            // Check if account type is TRS or TRP
            if (row.accountType === 'TRS' || row.accountType === 'TRP') {
              // For TRS and TRP, use totalScNetCost value as estimatedScgp
              if (row.totalScNetCost !== undefined) {
                row.estimatedScgp = row.totalScNetCost;
              }
            } else {
              // For all other account types, set estimatedScgp to a special "NA" marker
              row.estimatedScgp = 'NA';  // Use string 'NA' instead of null
            }
          });
        }
        break;
      case 3:
        if(!isSiteUser){
          title = `${regionTitle} - ${reportsKeyValue.region} - ${reportsKeyValue.opco} - ${t('summary_AccountType')} - ${reportsKeyValue.accountType}`;
        }else{ 
          title = `${accountTypeTitle} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType}`;
        }
       
        if(reportsKeyValue.offDaySales){
          title = `${title} - ${t('summary_offDay')}`;
        }
        dataSource = reportsCustomerData;
        totals = reportsCustomerTotals;
        footerData = JSON.parse(JSON.stringify(customerSummary));
        backTo=`/summary/${CONST_SUMMARY_PATH_LEVEL_MAPPING.filter(item=>item.level === level-1)[0].path}`;
        condition = {
          ...condition,
          accountTypes: reportsKeyValue.accountType ?[reportsKeyValue.accountType] : condition && condition.accountTypes,
          offDay: reportsKeyValue.offDaySales ? 'OFFDAY' : '',  //OFFDAY is hardcord flag for offday sales hyperlink
          sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
        }
        if (Array.isArray(dataSource)) {
          dataSource = dataSource.map(row => {
            if (!row) {
              return row;
            }
            // Check if account type is TRS or TRP
            if (row.accountType === 'TRS' || row.accountType === 'TRP') {
              const scgpValue = row.totalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              // For all other account types, set estimatedScgp to 'NA'
              return {
                ...row,
                estimatedScgp: 'NA',
              };
            }
          });
        }
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = customerSummary && customerSummary.estimatedScgp !== undefined ? customerSummary.estimatedScgp : 0;
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          footerData.estimatedScgp = isTrsOrTrpAccount ? summaryScgp : 'NA';
        }
        break;
      case 4:
        if(!isSiteUser){
          title = `${regionTitle} - ${reportsKeyValue.region} - ${t('summary_AccountType')} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType} - ${t('customer')} - ${reportsKeyValue.customerNumber}`;
        }else{
          title = `${accountTypeTitle} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType} - ${t('customer')} - ${reportsKeyValue.customerNumber}`;
        }
        if(reportsKeyValue.offDaySales){
          title = `${title} - ${t('summary_offDay')}`;
        }
        dataSource = reportsOrderData;
        totals = reportsOrderTotals;
        footerData = JSON.parse(JSON.stringify(orderSummary));
        backTo=`/summary/${CONST_SUMMARY_PATH_LEVEL_MAPPING.filter(item=>item.level === level-1)[0].path}`;
        condition = {
          ...condition,
          customerNumber: reportsKeyValue.customerNumber || '',
          accountTypes: reportsKeyValue.accountType ?[reportsKeyValue.accountType] : condition && condition.accountTypes,
          offDay: reportsKeyValue.offDaySales ? 'OFFDAY' : '',  //OFFDAY is hardcord flag for offday sales hyperlink
          sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
        }
        // Map orderTotalScNetCost to estimatedScgp for Summary order level
        if (Array.isArray(dataSource)) {
          dataSource = dataSource.map(row => {
            if (!row) return row;
            // Check if account type is TRS or TRP
            if (row.accountType === 'TRS' || row.accountType === 'TRP') {
              const scgpValue = row.orderTotalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              // For all other account types, set estimatedScgp to 'NA'
              return {
                ...row,
                estimatedScgp: 'NA',
              };
            }
          });
        }
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = orderSummary && orderSummary.estimatedScgp !== undefined ? orderSummary.estimatedScgp : 0;
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          footerData.estimatedScgp = isTrsOrTrpAccount ? summaryScgp : 'NA';
        }
        break;
      case 5:
        if(!isSiteUser){
          title = `${regionTitle} - ${reportsKeyValue.region} - ${t('summary_AccountType')} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('order')} - ${reportsKeyValue.orderNumber}`;
        }else{
          title = `${accountTypeTitle} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('order')} - ${reportsKeyValue.orderNumber}`;
        }
        if(reportsKeyValue.offDaySales){
          title = `${title} - ${t('summary_offDay')}`;
        }
        dataSource = reportsOrderDetailData;
        totals = reportsOrderDetailTotals;
        footerData = JSON.parse(JSON.stringify(orderDetailSummary));
        backTo=`/summary/${CONST_SUMMARY_PATH_LEVEL_MAPPING.filter(item=>item.level === level-1)[0].path}`;
        condition = {
          orderNumber: reportsKeyValue.orderNumber || '',
          site: reportsKeyValue.site,
        }
        // Map totalScNetCost to estimatedScgp for Order Detail level
        if (Array.isArray(dataSource)) {
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          dataSource = dataSource.map(row => {
            if (!row) return row;
            if (isTrsOrTrpAccount) {
              const scgpValue = row.totalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              return { ...row, estimatedScgp: 'NA' };
            }
          });
        }
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = orderDetailSummary && orderDetailSummary.estimatedScgp !== undefined ? orderDetailSummary.estimatedScgp : 0;
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          footerData.estimatedScgp = isTrsOrTrpAccount ? summaryScgp : 'NA';
        }
        break;
      default:
        backTo=`/summary`;
      }
  }
  if(tabKey === 'Orders' || tabKey === 'Future Orders'){
    let routePath = tabKey === 'Orders'?'orders':'future-orders';
    switch (level) {
      case 1:
        title = t(tabKey);
        dataSource = reportsData;
        totals = reportsTotals;
        footerData = JSON.parse(JSON.stringify(summary));
        backTo = ``;
        condition = {
          ...condition,
          futureOrders: tabKey === 'Future Orders' ? 'futureOrders' : null,
        }
        // Level 1 Orders / Future Orders: map row totalScNetCost 
        if ((tabKey === 'Orders' || tabKey === 'Future Orders') && Array.isArray(dataSource)) {
          dataSource.forEach(row => {
            if (row && row.totalScNetCost !== undefined) {
              row.estimatedScgp = row.totalScNetCost === null ? 0 : row.totalScNetCost;
            }
          });
        }
        if ((tabKey === 'Orders' || tabKey === 'Future Orders') && footerData && (footerData.estimatedScgp === undefined || footerData.estimatedScgp === null)) {
          const sumEst = Array.isArray(dataSource) ? dataSource.reduce((acc, r) => acc + (r && r.totalScNetCost ? r.totalScNetCost : 0), 0) : 0;
          footerData.estimatedScgp = sumEst > 0 ? parseFloat(sumEst.toFixed(2)) : 0;
        }
        break;
      case 2:
        title = `${t(tabKey)} ${t('forChannelType')} - ${reportsKeyValue.orderChannelType}`;
        dataSource = reportsCustomerData;
        totals = reportsCustomerTotals;
        footerData = JSON.parse(JSON.stringify(customerSummary));
        backTo = `/${routePath}`;
        condition = {
          ...condition,
          channelType: reportsKeyValue.remoteOrderEntryMode || '', //parse remoteOrderEntryMode to channelType into param
          // offDay: reportsKeyValue.offDaySales ? 'OFFDAY' : '',  //OFFDAY is hardcord flag for offday sales hyperlink
          sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
          futureOrders: tabKey === 'Future Orders' ? 'futureOrders' : null
        }
        // Level 2 (Account Type / Customer aggregate) added estimatedScgp column derived from totalScNetCost per row.
        //Mixed account types: only TRS/TRP keep numeric estimatedScgp; others set to 'NA'.
        if (Array.isArray(dataSource)) {
          dataSource.forEach(row => {
            if (!row) return;
            if (row.accountType === 'TRS' || row.accountType === 'TRP') {
              if (row.totalScNetCost !== undefined) {
                row.estimatedScgp = row.totalScNetCost == null ? 0 : row.totalScNetCost;
              }
            } else {
              row.estimatedScgp = 'NA';
            }
          });
        }
        // Footer: sum only TRS/TRP rows (ignore 'NA').
        if (footerData && (footerData.estimatedScgp === undefined || footerData.estimatedScgp === null)) {
          const sumEst = Array.isArray(dataSource)
            ? dataSource.reduce((acc, r) => {
                if (r && (r.accountType === 'TRS' || r.accountType === 'TRP')) {
                  return acc + (r.totalScNetCost ? r.totalScNetCost : 0);
                }
                return acc;
              }, 0)
            : 0;
          footerData.estimatedScgp = sumEst > 0 ? parseFloat(sumEst.toFixed(2)) : 0;
        }
        break;
      case 3:
        title = `${t(tabKey)} ${t('forChannelType')} - ${reportsKeyValue.orderChannelType} - ${t('summary_AccountType')} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType}`;
        if(reportsKeyValue.offDaySales){
          title = `${t(tabKey)} ${t('forChannelType')} - ${reportsKeyValue.orderChannelType} - ${t('summary_AccountType')} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType} - ${t('summary_offDay')}`;
        }
        dataSource = reportsOrderData;
        totals = reportsOrderTotals;
        footerData = JSON.parse(JSON.stringify(orderSummary));
        backTo = `/${routePath}/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level-1)[0].path}`
        condition = {
          ...condition,
          channelType: reportsKeyValue.remoteOrderEntryMode || '', //parse remoteOrderEntryMode to channelType into param
          accountTypes: reportsKeyValue.accountType ?[reportsKeyValue.accountType] : condition && condition.accountTypes,
          offDay: reportsKeyValue.offDaySales ? 'OFFDAY' : '',  //OFFDAY is hardcord flag for offday sales hyperlink
          sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
          futureOrders: tabKey === 'Future Orders' ? 'futureOrders' : null
        }
        // Map orderTotalScNetCost to estimatedScgp for Orders/Future Orders order level (level 3)
        if (Array.isArray(dataSource)) {
          dataSource = dataSource.map(row => {
            if (!row) return row;
            // Check if account type is TRS or TRP
            if (row.accountType === 'TRS' || row.accountType === 'TRP') {
              const scgpValue = row.orderTotalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              // For all other account types, set estimatedScgp to 'NA'
              return { ...row, estimatedScgp: 'NA' };
            }
          });
        }
        // Footer: set estimatedScgp based on TRS/TRP account type
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = orderSummary && orderSummary.estimatedScgp !== undefined ? orderSummary.estimatedScgp : 0;
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          footerData.estimatedScgp = isTrsOrTrpAccount ? summaryScgp : 'NA';
        }
        break;
      case 4:
        title = `${t(tabKey)} ${t('forChannelType')} - ${reportsKeyValue.orderChannelType} - ${t('summary_AccountType')} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType} - ${t('order')} - ${reportsKeyValue.orderNumber}`;
        if(reportsKeyValue.offDaySales){
          title = `${t(tabKey)} ${t('forChannelType')} - ${reportsKeyValue.orderChannelType} - ${t('summary_AccountType')} - ${reportsKeyValue.opco} - ${reportsKeyValue.accountType} - ${t('order')} - ${reportsKeyValue.orderNumber} - ${t('summary_offDay')}`;
        }
        dataSource = reportsOrderDetailData;
        totals = reportsOrderDetailTotals;
        footerData = JSON.parse(JSON.stringify(orderDetailSummary));
        backTo = `/${routePath}/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level-1)[0].path}`
        condition = {
          orderNumber: reportsKeyValue.orderNumber || '',
          site: reportsKeyValue.site,
        }
        // Map totalScNetCost to estimatedScgp for Orders/Future Orders order detail level (level 4)
        if (Array.isArray(dataSource)) {
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          dataSource = dataSource.map(row => {
            if (!row) return row;
            if (isTrsOrTrpAccount) {
              const scgpValue = row.totalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              return { ...row, estimatedScgp: 'NA' };
            }
          });
        }
        // Footer: set estimatedScgp based on TRS/TRP account type
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = orderDetailSummary && orderDetailSummary.estimatedScgp !== undefined ? orderDetailSummary.estimatedScgp : 0;
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          footerData.estimatedScgp = isTrsOrTrpAccount ? summaryScgp : 'NA';
        }
        break;
      default:
        backTo=`/${routePath}`;
      }
  }
  if(tabKey === 'SC in Action'){
    switch (level) {
      case 1:
        title = `${t(tabKey)}`;
        dataSource = reportsData;
        totals = reportsTotals;
        footerData = JSON.parse(JSON.stringify(summary));
        backTo='';
        // Map totalScNetCost from API to estimatedScgp for table body rows 
        if (dataSource && Array.isArray(dataSource)) {
          dataSource.forEach(row => {
            if (row.totalScNetCost !== undefined) {
              row.estimatedScgp = row.totalScNetCost === null ? 0 : row.totalScNetCost;
            }
          });
        }
        // Ensure footer ALL row has estimatedScgp 
        if (footerData && (footerData.estimatedScgp === undefined || footerData.estimatedScgp === null)) {
          const sumEst = Array.isArray(dataSource) ? dataSource.reduce((acc, r) => acc + (r.totalScNetCost ? r.totalScNetCost : 0), 0) : 0;
            footerData.estimatedScgp = sumEst > 0 ? parseFloat(sumEst.toFixed(2)) : 0;
        }
        break;
      case 2:
        title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId}`;
        if(reportsKeyValue.offDayOrders){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('order_offDayOrders')}`;
        }else if(reportsKeyValue.largeHits){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('largeHits')}`;
        }else if(reportsKeyValue.orderUnderMin){
          title = `${t(tabKey)} ${t('forTerritory')}- ${reportsKeyValue.scId} - ${t('underXOrY')}`;
        }
        dataSource = reportsCustomerData;
        totals = reportsCustomerTotals;
        footerData = JSON.parse(JSON.stringify(customerSummary));
        backTo=`/sc-in-action`;
        condition = {
          ...condition,
          scId: reportsKeyValue.scId || '',
          largeHits: reportsKeyValue.largeHits ? 'LH' : '',
          orderUnderMin: reportsKeyValue.orderUnderMin ? 'OUM' : '',
          offDay: reportsKeyValue.offDayOrders ? 'OFFDAY' : '', //OFFDAY is hardcord flag for offday sales hyperlink
          sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
        }
        // Map totalScNetCost to estimatedScgp for SC in Action customer level (level 2)
        if (Array.isArray(dataSource)) {
          dataSource = dataSource.map(row => {
            if (!row) return row;
            if (row.accountType === 'TRS' || row.accountType === 'TRP') {
              const scgpValue = row.totalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              return { ...row, estimatedScgp: 'NA' };
            }
          });
        }
        // Footer: If ALL rows are non-TRS/TRP, show NA; otherwise show summary value
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = customerSummary && customerSummary.estimatedScgp !== undefined ? customerSummary.estimatedScgp : 0;
          const hasAnyTrsOrTrp = Array.isArray(dataSource) && dataSource.some(row => row && (row.accountType === 'TRS' || row.accountType === 'TRP'));
          footerData.estimatedScgp = hasAnyTrsOrTrp ? summaryScgp : 'NA';
        }
        break;
      case 3:
        title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber}`;
        if(reportsKeyValue.offDayOrders){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('order_offDayOrders')}`;
        }else if(reportsKeyValue.largeHits){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber} -  ${t('largeHits')}`;
        }else if(reportsKeyValue.orderUnderMin){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('underXOrY')}`;
        }
        dataSource = reportsOrderData;
        totals = reportsOrderTotals;
        footerData = JSON.parse(JSON.stringify(orderSummary));
        backTo=`/sc-in-action/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level-1)[0].path}`;
        condition = {
          ...condition,
          scId: reportsKeyValue.scId || '',
          largeHits: reportsKeyValue.largeHits ? 'LH' : '',
          orderUnderMin: reportsKeyValue.orderUnderMin ? 'OUM' : '',
          offDay: reportsKeyValue.offDayOrders ? 'OFFDAY' : '', //OFFDAY is hardcord flag for offday sales hyperlink
          customerNumber: reportsKeyValue.customerNumber || '',
          sites: reportsKeyValue.opco ? [reportsKeyValue.opco] : condition && condition.sites,
        };
        // Map orderTotalScNetCost to estimatedScgp for SC in Action order level (level 3)
        // Use accountType from reportsKeyValue (passed from level 2 navigation)
        if (Array.isArray(dataSource)) {
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          dataSource = dataSource.map(row => {
            if (!row) return row;
            if (isTrsOrTrpAccount) {
              const scgpValue = row.orderTotalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              return { ...row, estimatedScgp: 'NA' };
            }
          });
        }
        // Footer: Check TRS/TRP from reportsKeyValue.accountType
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = orderSummary && orderSummary.estimatedScgp !== undefined ? orderSummary.estimatedScgp : 0;
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          footerData.estimatedScgp = isTrsOrTrpAccount ? summaryScgp : 'NA';
        }
        break;
      case 4:
        title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('order')} - ${reportsKeyValue.orderNumber}`;
        if(reportsKeyValue.offDayOrders){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('order')} - ${reportsKeyValue.orderNumber} - ${t('order_offDayOrders')}`;
        }else if(reportsKeyValue.largeHits){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('order')} - ${reportsKeyValue.orderNumber} - ${t('largeHits')}`;
        }else if(reportsKeyValue.orderUnderMin){
          title = `${t(tabKey)} ${t('forTerritory')} - ${reportsKeyValue.scId} - ${t('customer')} - ${reportsKeyValue.customerNumber} - ${t('order')} - ${reportsKeyValue.orderNumber} - ${t('underXOrY')}`;
        }
        dataSource = reportsOrderDetailData;
        totals = reportsOrderDetailTotals;
        footerData = JSON.parse(JSON.stringify(orderDetailSummary));
        backTo=`/sc-in-action/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level-1)[0].path}`;
        condition = {
          orderNumber: reportsKeyValue.orderNumber || '',
          site: reportsKeyValue.site,
        };
        // Map totalScNetCost to estimatedScgp for SC in Action item level (level 4)
        // Use accountType from reportsKeyValue (passed from level 2/3 navigation)
        if (Array.isArray(dataSource)) {
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          dataSource = dataSource.map(row => {
            if (!row) return row;
            if (isTrsOrTrpAccount) {
              const scgpValue = row.totalScNetCost;
              return {
                ...row,
                estimatedScgp: scgpValue === null || scgpValue === undefined ? 0 : scgpValue,
              };
            } else {
              return { ...row, estimatedScgp: 'NA' };
            }
          });
        }
        // Footer: Check TRS/TRP from reportsKeyValue.accountType
        if (footerData && typeof footerData === 'object') {
          const summaryScgp = orderDetailSummary && orderDetailSummary.estimatedScgp !== undefined ? orderDetailSummary.estimatedScgp : 0;
          const isTrsOrTrpAccount = reportsKeyValue.accountType === 'TRS' || reportsKeyValue.accountType === 'TRP';
          footerData.estimatedScgp = isTrsOrTrpAccount ? summaryScgp : 'NA';
        }
        break;
      default:
        backTo=`/sc-in-action`;
      }
  }
  if(tabKey === 'OOS Item'){
    switch (level) {
      case 1:
        title = `${t(tabKey)}`;
        dataSource = reportsData;
        totals = reportsTotals;
        footerData = JSON.parse(JSON.stringify(summary));
        backTo='';
        break;
      case 2:
        // title = `${tabKey} for AccountType - ${reportsKeyValue.accountType}`;
        if(reportsKeyValue.category){
          title = `${t(tabKey)} ${t('forCategory')} - ${reportsKeyValue.category}`;
        }
        dataSource = reportsOrderData;
        totals = reportsOrderTotals;
        footerData = JSON.parse(JSON.stringify(orderSummary));
        backTo=`/out-of-stock`;
        condition = {
          ...condition,
          category: reportsKeyValue.category || '',
          sites: reportsKeyValue.site ? [reportsKeyValue.site] : condition && condition.sites,
        }
        break;
      case 3:
        title = `${t(tabKey)} ${t('forCategory')} - ${reportsKeyValue.category} - ${t('item#')} - ${reportsKeyValue.itemNumber}`;
        dataSource = reportsCustomerData;
        totals = reportsCustomerTotals;
        footerData = JSON.parse(JSON.stringify(customerSummary));
        backTo=`/out-of-stock/order`;
        condition = {
          ...condition,
          category: reportsKeyValue.category || '',
          sites: reportsKeyValue.site ? [reportsKeyValue.site] : condition && condition.sites,
          itemNumber: reportsKeyValue.itemNumber || '',
        };
        break;
      default:
        backTo=`/out-of-stock`;
      }
  }
  if(tabKey === 'OOS Account'){
    switch (level) {
      case 1:
        title = `${t('oosAccount')}`;
        dataSource = reportsData;
        totals = reportsTotals;
        footerData = JSON.parse(JSON.stringify(summary));
        backTo='';
        break;
      case 2:
        // title = `${tabKey} for AccountType - ${reportsKeyValue.accountType}`;
        if(reportsKeyValue.accountType){
          title = `${t('oosAccount')} ${t('forAccountType')} - ${reportsKeyValue.accountType}`;
        }
        dataSource = reportsCustomerData;
        totals = reportsCustomerTotals;
        footerData = JSON.parse(JSON.stringify(customerSummary));
        backTo=`/oos-account`;
        condition = {
          ...condition,
          accountTypes: reportsKeyValue.accountType ?[reportsKeyValue.accountType] : condition && condition.accountTypes,
          sites: reportsKeyValue.site ? [reportsKeyValue.site] : condition && condition.sites,
        }
        break;
      case 3:
        title = `${t('oosAccount')} ${t('forAccountType')} - ${reportsKeyValue.accountType} - ${t('customer')} - ${reportsKeyValue.customerNumber}`;
        dataSource = reportsOrderData;
        totals = reportsOrderTotals;
        footerData = JSON.parse(JSON.stringify(orderSummary));
        backTo=`/oos-account/customer`;
        condition = {
          ...condition,
          accountTypes: reportsKeyValue.accountType ?[reportsKeyValue.accountType] : condition && condition.accountTypes,
          sites: reportsKeyValue.site ? [reportsKeyValue.site] : condition && condition.sites,
          customerNumber: reportsKeyValue.customerNumber || '',
        };
        break;
      default:
        backTo=`/oos-account`;
      }
  }
  //  Canada override: after all dataSource/footerData construction, force Estimated SC-GP to 'NA'
  if (isCanadaSeller()) {
    if (Array.isArray(dataSource)) {
      dataSource = dataSource.map(row => row ? { ...row, estimatedScgp: 'NA' } : row);
    }
    if (footerData && typeof footerData === 'object') {
      footerData.estimatedScgp = 'NA';
    }
  }
  const reportActionIndex = {
    'Summary': {
      0: data => fetchSummaryDataByRegion(data),
      1: data => fetchSummaryDataBySite(data),
      2: data => fetchSummaryData(data),
      3: data => fetchSummaryCustomerData(data),
      4: data => fetchSummaryOrderData(data),
      5: data => fetchOrderDetailReport(data),
    }, 
    'SC in Action':{
      1: data => fetchScInActionData(data),
      2: data => fetchScInActionCustomerData(data),
      3: data => fetchScInActionOrderData(data),
      4: data => fetchOrderDetailReport(data),
    },
    'Orders':{
      1: data => fetchOrdersReportByChannelType(data),
      2: data => fetchSummaryDataFromChannelType(data),
      3: data => fetchOrdersData(data),
      4: data => fetchOrderDetailReport(data),
    },
    'Future Orders':{
      1: data => fetchOrdersReportByChannelType(data),
      2: data => fetchSummaryDataFromChannelType(data),
      3: data => fetchOrdersData(data),
      4: data => fetchOrderDetailReport(data),
    },
    'OOS Item':{
      1: data => fetchOosReportBySite(data),
      2: data => fetchOosReportByCategory(data),
      3: data => fetchOosReportByOrderNumber(data),
    },
    'OOS Account':{
      1: data => fetchOosAccountAccountType(data),
      2: data => fetchOosAccountCustomer(data),
      3: data => fetchOosAccountOrder(data),
    }
  };
  const exportReportActionIndex = {
    'Summary': {
      0: data => exportSummaryRegionReport(data),
      1: data => exportSummaryDataBySite(data),
      2: data => exportSummaryReport(data),
      3: data => exportSummaryCustomerReport(data),
      4: data => exportSummaryOrderReport(data),
      5: data => exportOrderDetailReport(data),
    },
    'SC in Action': {
      1: data => exportScInActionReportData(data),
      2: data => exportScInActionCustomerReport(data),
      3: data => exportScInActionOrderReport(data),
      4: data => exportOrderDetailReport(data),
    },
    'Orders':{
      1: data => exportOrdersReportByChannelType(data),
      2: data => exportSummaryReport(data),
      3: data => exportOrdersReport(data),
      4: data => exportOrderDetailReport(data),
    },
    'Future Orders':{
      1: data => exportOrdersReportByChannelType(data),
      2: data => exportSummaryReport(data),
      3: data => exportOrdersReport(data),
      4: data => exportOrderDetailReport(data),
    },
    'OOS Item':{
      1: data => exportOosReportBySite(data),
      2: data => exportOosReportByCategory(data),
      3: data => exportOosReportByOrderNumber(data),
    },
    'OOS Account':{
      1: data => exportOosAccountAccountType(data),
      2: data => exportOosAccountCustomer(data),
      3: data => exportOosAccountOrder(data),
    }
  };

  const fetchOrderReportList = (paginationInfo, sortingInfo) => {
    const formdata = {
      ...condition,
      // futureOrders: tabKey === 'Future Orders' ? 'futureOrders' : null,
      pageIndex: paginationInfo.pageIndex,
      pageSize: paginationInfo.pageSize,
      ...sortingInfo,
    };
    const timing = Date.now();
    reportActionIndex[tabKey][level](formdata);
    datadogRum.onReady(function(){
      datadogRum.addTiming(`Fetch ${title} report`,timing);
    });
  };
  const exportReports = () => {
    if (totals > 5001) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
      let sheetColConfig = [];
      columnsProp.forEach(col => {
        col.title = t(col.title);
        let sheetColWidth = 12;
        if (col.width) {
          sheetColWidth = col.width / 10;
        }
        sheetColConfig.push({ wch: sheetColWidth });
      });
      const timing = Date.now();
      exportReportActionIndex[tabKey][level]({
        ...condition,
        futureOrders: tabKey === 'Future Orders' ? 'futureOrders' : null,
        ...sorting,
      }).then(data => {
        // Transform data for export: Map totalScNetCost to estimatedScgp and apply business rules
        const transformedData = data.map(row => {
          const transformedRow = { ...row };
          
          // Check if this row has estimatedScgp column (exists in columnsProp)
          const hasEstimatedScgpColumn = columnsProp.some(col => col.dataIndex === 'estimatedScgp');
          
          if (hasEstimatedScgpColumn) {
            // Get the source value: use orderTotalScNetCost for order-level (Summary level 4, Orders/Future Orders level 3, SC in Action level 3), otherwise totalScNetCost
            const isOrderLevel = (tabKey === 'Summary' && level === 4) || ((tabKey === 'Orders' || tabKey === 'Future Orders') && level === 3) || (tabKey === 'SC in Action' && level === 3);
            let scgpValue = isOrderLevel
              ? transformedRow.orderTotalScNetCost 
              : transformedRow.totalScNetCost;
            
            // Business rule: Check if Canada seller (CABL)
            const isCanada = isCanadaSeller();
            
            // Business rule: Check if account level data (NOT TRS or TRP, then show NA)
            // For Order Detail level (Summary level 5, Orders/Future Orders level 4, SC in Action level 4) and order level (SC in Action level 3), use parent account type from reportsKeyValue
            let accountType = transformedRow.accountType || '';
            if ((tabKey === 'Summary' && level === 5) || ((tabKey === 'Orders' || tabKey === 'Future Orders') && level === 4) || (tabKey === 'SC in Action' && (level === 3 || level === 4))) {
              accountType = reportsKeyValue.accountType || '';
            }
            const isAccountLevelNotTrsOrTrp = accountType && accountType !== 'TRS' && accountType !== 'TRP';
            
            // Apply rules: If Canada or (account level and NOT TRS/TRP), set to 'NA'
            if (isCanada || isAccountLevelNotTrsOrTrp) {
              transformedRow.estimatedScgp = 'NA';
            } else {
              // Map source field to estimatedScgp, format as number with 2 decimals
              // If undefined, null, or zero, show as 0.00 (no dollar sign in Excel)
              if (scgpValue === undefined || scgpValue === null || scgpValue === 0) {
                transformedRow.estimatedScgp = '0.00';
              } else {
                // Format number with 2 decimal places
                transformedRow.estimatedScgp = Number(scgpValue).toFixed(2);
              }
            }
          }
          
          return transformedRow;
        });
        
        const sheetObj = [{
          headers: renderTableColumns(columnsProp.map(item => {
            item.title = t(item.title);
            return item;
          }), tabKey, renderElementIndex),
          data: transformedData,
          sheetName: null,
          sheetColConfig,
        }];
        downloadFile(`${title} Report`, sheetObj);
        datadogRum.addAction(`Export ${title} report`,{
          headers: renderTableColumns(columnsProp.map(item => {
            item.title = t(item.title);
            return item;
          }), tabKey, renderElementIndex),
          data: transformedData,
          sheetName: null,
          sheetColConfig,
        });
      });
      datadogRum.onReady(function(){
        datadogRum.addTiming(`Export ${title} report`,timing);
      });
    }
  };
  const renderTableLinkButton = (value, label, record, isNestColumn) => {
    return (
      <Button
        type="link"
        onClick={
          () => handleOnRowClick(value, label, record)
        }
        className={(label === 'offDaySales' || ((label === 'offDayOrders' || label === 'largeHits' || label === 'underXOrY') && tabKey === 'SC in Action')) && value === 0?"ant-btn-link-disabled":""}
      >
       {label === 'offDaySales'? `$${returnFloat(value)}`: label === 'scId'?renderMergedColumn(record.scName,record.scId,'-'):label === 'orderChannelType' && value==='SMX'?'SMX/Source':value}
      </Button>
    );
  };
  const renderBadge = (value, label) => {
    if (label === 'largeHits' && value === 'Y') {
      return <Badge className="order-badge-item" color="#56B146" />;
    } else if (label === 'underXOrY' && value === 'Y') {
      return <Badge className="order-badge-item" color="#D0021B" />;
    } else if (label === 'offDay' && value === 'Y') {
      return <Badge className="order-badge-item" color="#6A737B" />;
    } else {
      return null;
    }
  };
  const renderElementIndex = {
    toggleModal: renderTableLinkButton,
    renderBadge: renderBadge,
  };
  //insert all index into summary data
  if (footerData) {
    footerData.totalIndex = true;
  }
  // Footer columns (already have Canada override inside convertToFooterColumns)
  let footerTableColumns = renderTableColumns(convertToFooterColumns(columnsProp.map(item => {
    item.title = t(item.title);
    return item;
  })), tabKey, renderElementIndex);

  // Main table columns: add explicit Canada render override for estimatedScgp to avoid "$NA"
  const tableColumnsWithCanada = columnsProp.map(col => {
    const newCol = { ...col, title: t(col.title) };
    if (newCol.dataIndex === 'estimatedScgp') {
      const originalRender = newCol.render;
      newCol.render = (value, record, index) => {
        // Force NA for Canada
        if (isCanadaSeller()) return 'NA';
        // Preserve existing NA marker
        if (value === 'NA') return 'NA';
        // If an original custom render exists, let it handle (unless it would prepend "$" to a string)
        if (originalRender) {
          try {
            return originalRender(value, record, index);
          } catch (e) {
             /* eslint-disable no-console */
            console.error('estimatedScgp originalRender failed:', e);
          }
        }
        if (value === null || value === undefined || value === 0) return '$0.00';
        return `$${value.toLocaleString('zh', { minimumFractionDigits: 2 })}`;
      };
    }
    return newCol;
  });
  const renderFooter = () => {
    if(level === 4){
      footerData = {...footerData,itemDescription:totals};
    }

    if (footerData && !_.isEmpty(dataSource)) {
      return (
        <TableFooter tabKey={tabKey} summary={footerData} columns={footerTableColumns} />
      )
    }
  }
  const onTableChange = (page, filters, sorter) => {
    setShowAlert(false);
    // const sort =
    //   Object.keys(sorter).length > 0 && sorter.order !== undefined
    //     ? {
    //       sortedBy: sorter.field,
    //       sort: sorter.order,
    //     }
    //     : sorting;
    let sort = {};
  if (Object.keys(sorter).length > 0 && sorter.order !== undefined) {
    // Map estimatedScgp sorting to the correct backend field
    // For order level (Summary level 4, Orders/Future Orders level 3, SC in Action level 3), use orderTotalScNetCost; otherwise use totalScNetCost
    let sortField = sorter.field;
    if (sorter.field === 'estimatedScgp') {
      const isOrderLevel = (tabKey === 'Summary' && level === 4) || ((tabKey === 'Orders' || tabKey === 'Future Orders') && level === 3) || (tabKey === 'SC in Action' && level === 3);
      sortField = isOrderLevel ? 'orderTotalScNetCost' : 'totalScNetCost';
    }
    
    sort = {
      sortedBy: sortField,
      sort: sorter.order,
    };
  } else {
    sort = sorting;
  }
  
    setPagination({
      ...pagination,
      pageIndex: 1,
    });
    setSorting(sort);
  };
  const onPaginationChange = (page, changedPageSize) => {
    setShowAlert(false);
    let currPageIndex = page;
    if (pagination.pageSize !== changedPageSize) {
      currPageIndex = 1;
    }
    setPagination({
      ...pagination,
      pageIndex: currPageIndex,
      pageSize: changedPageSize,
    });
  };
  const handleOnRowClick = (value, label, record) => {
    if(tabKey === 'Summary'){
      switch (level){
        case 0:
          history.push('/summary/site-sales');
          saveReportsKeyValue({ ...reportsKeyValue, [label]: value,tabKey:tabKey, });
          break;
        case 1:
          history.push('/summary/account-type');
          saveReportsKeyValue({ ...reportsKeyValue, tabKey:tabKey, opco: record && record.site});
          break;
        case 2:
          history.push('/summary/customer');
          let opco = {
            opco: record && record.site,
          }
          let objOffday = {};
          if (label === 'offDaySales') {
            objOffday = {
              accountType: record.accountType,
            };
          }
          saveReportsKeyValue({ ...reportsKeyValue, ...objOffday, ...opco, [label]: value,tabKey:tabKey, });
          break;
        case 3:
          history.push('/summary/order');
          saveReportsKeyValue({...reportsKeyValue,[label]:value,tabKey:tabKey});
          break;
        case 4:
          history.push('/summary/order-detail');
          saveReportsKeyValue({...reportsKeyValue,[label]:value,tabKey:tabKey,site:record.site});
          break;
        default:
      }
    }
    if(tabKey === 'Orders' || tabKey === 'Future Orders'){
      const routePath = tabKey === 'Orders'?'orders':'future-orders'
      switch (level){
        case 1:
          history.push(`/${routePath}/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level+1)[0].path}`);
          saveReportsKeyValue({
            ...reportsKeyValue, 
            remoteOrderEntryMode: record.remoteOrderEntryMode,
            orderChannelType: record.orderChannelType,
            tabKey:tabKey,
          });
          break;
        case 2:
          history.push(`/${routePath}/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level+1)[0].path}`);
          let opco = {
            opco: record && record.site,
          }
          let objOffday = {};
          if (label === 'offDaySales') {
            objOffday = {
              accountType: record.accountType,
            };
          }
          saveReportsKeyValue({ ...reportsKeyValue, ...objOffday, ...opco, [label]: value,tabKey:tabKey, });
          break;
        case 3:
            history.push(`/${routePath}/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level+1)[0].path}`);
            saveReportsKeyValue({ ...reportsKeyValue, [label]: value,tabKey:tabKey,site:record.site });
        default:
      }
    }
    if(tabKey === 'SC in Action') {
      let customerParam = { scId: record.scId,opco: record && record.site};
      switch(level){
        case 1:
          history.push(`/sc-in-action/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level+1)[0].path}`);
          if (label === 'offDayOrders') {
            customerParam ={
              ...customerParam,
              offDayOrders: value,
            }
          } else if (label === 'largeHits') {
            customerParam ={
              ...customerParam,
              largeHits: record.largeHits
            }
          } else if (label === 'underXOrY') {
            customerParam ={
              ...customerParam,
              orderUnderMin: record.underXOrY,
            }
          } 
          saveReportsKeyValue({
            ...reportsKeyValue,
            ...customerParam,
            tabKey: tabKey,
          });
          break;
          case 2: 
          history.push(`/sc-in-action/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level+1)[0].path}`);
          saveReportsKeyValue({...reportsKeyValue,[label]:value,tabKey:tabKey,accountType:record.accountType});
          break;
          case 3: 
          history.push(`/sc-in-action/${CONST_PATH_LEVEL_MAPPING.filter(item=>item.level === level+1)[0].path}`);
          saveReportsKeyValue({...reportsKeyValue,[label]:value,tabKey:tabKey,site:record.site,accountType:reportsKeyValue.accountType});
          break;
        }
      }
    if(tabKey === 'OOS Item'){
      switch (level){
        case 1:
          history.push('/out-of-stock/order');
          let site = {
            site: record && record.site,
          }
          saveReportsKeyValue({ ...reportsKeyValue, ...site, [label]: value,tabKey:tabKey, });
          break;
        case 2:
          history.push('/out-of-stock/customer');
          let condition = {
            itemNumber: record && record.itemNumber,
            orderNumber: record && record.orderNumber,
            site: record && record.site,
          }
          saveReportsKeyValue({...reportsKeyValue,...condition,tabKey:tabKey});
          break;
        default:
      }
    }
    if(tabKey === 'OOS Account'){
      switch (level){
        case 1:
          history.push('/oos-account/customer');
          let site = {
            site: record && record.site,
          }
          saveReportsKeyValue({ ...reportsKeyValue, ...site, [label]: value,tabKey:tabKey, });
          break;
        case 2:
          history.push('/oos-account/order');
          if(label === "customerShipTo"){
            label = "customerNumber";
          }
          let condition = {
            site: record && record.site,
          }
          saveReportsKeyValue({...reportsKeyValue,...condition,tabKey:tabKey,[label]:value});
          break;
        default:
      }
    }
      resetReportsData();
      resetReportsCustomerLevelData();
      resetReportsDataOrders();
  }
  const renderMobileValue =(value,dataIndex,record,colItem)=>{
    if (colItem.toggleModal) {
      return renderTableLinkButton(value, dataIndex, record);
    } else if (dataIndex === 'estimatedScgp') {
      // Handle the 'NA' case for non-TRS/TRP account types
      if (value === 'NA') {
        return 'NA';
      }
      // For TRS/TRP - same logic as other currency fields
      if (value === null || value === undefined || value === 0) {
        return '$0.00';
      }
      return `$${value.toLocaleString('zh', { minimumFractionDigits: 2 })}`;
    } else if (dataIndex === 'totalSales' || dataIndex === 'averageSell'
      || dataIndex === 'offDaySales' || dataIndex === 'orderTotalSales'
      || dataIndex === 'lostSales') {
      return value === null || value === 0 ? '$0.00' : value && `$${value.toLocaleString('zh',{minimumFractionDigits:2})}`;
    } else if (dataIndex === 'totalGP' || dataIndex === 'salesPercentage' || dataIndex === 'preShipDirSubs' || dataIndex === 'preShipAllSubs') {
      return value === null || value === 0 ? '0.00%' : value && `${value.toLocaleString('zh',{minimumFractionDigits:2})}%`;
    // } else if (dataIndex === 'underXOrY' || dataIndex === 'offDay' || dataIndex === 'largeHits') {
    //   return value === 'Y' ? 'Yes' : value === 'N' ? 'No' : null;
    }else if(dataIndex === 'orderDetailExtendedPrice' || dataIndex === 'originalItemUnitPrice'){
      return value === null || value === 0 ? '$0.00' : value && `$${value.toLocaleString('zh',{minimumFractionDigits:2})}`;
    }else if(dataIndex === 'scId'){
      return renderMergedColumn(record.scName,record.scId,'-')
    }else if(dataIndex === 'district'){
      return renderMergedColumn(record.dsmName,record.district,'-')
    }else if(dataIndex === 'region'){
      return renderMergedColumn(record.rsmName,record.region,'-')
    }
     else {
      return `${value}`;
    }
  }
  return (
    <div className="reports-new-common-page" id={`${tabKey}-${level}`}>
      <div className={isOpenPop ? "sys-mark fadeIn is-show-mobile":"sys-mark fadeOut none"}></div>
      <div className="sia-container">
        <ExportAlertModal showAlert={showAlert} setShowAlert={setShowAlert} />
        <Header backTo={backTo} title={title} level={level} />
        <div className="report-new-export">
          <ExportButton dataSource={dataSource} exportReports={exportReports} />
        </div>
        
      </div>
      <TotalPanel tabKey={tabKey} footerColumns={footerTableColumns} footerData={footerData} level={level} accountType={reportsKeyValue.accountType}/>
      <div className='reports-new-tables'>
        <div className='reports-result-panel'>
          {showFilter && <ReportsFilter isOpenPop = {isOpenPop} isOpenPopFun={isOpenPopFun} isClosePopFun={isClosePopFun}/>}
          <Table
            rowKey={record => Math.random()}
            className="report-new-table is-show-pc"
            loading={fetchScInActionDataPending || fetchSummaryDataPending || fetchOrdersReportByChannelTypePending 
              || exportSummaryReportPending || exportOrdersReportByChannelTypePending || exportScInActionReportDataPending 
              || fetchSummaryCustomerDataPending || fetchSummaryOrderDataPending || exportSummaryCustomerReportPending || exportSummaryOrderReportPending 
              || fetchScInActionCustomerDataPending || fetchScInActionOrderDataPending || exportScInActionCustomerReportPending || exportScInActionOrderReportPending||
              fetchSummaryDataFromChannelTypePending || fetchOrdersDataPending || exportOrdersReportPending ||
              fetchOrderDetailReportPending || exportOrderDetailReportPending 
              || fetchSummaryDataByRegionPending || exportSummaryRegionReportPending
              || fetchOosReportBySitePending || fetchOosReportByCategoryPending || fetchOosReportByOrderNumberPending 
              || exportOosReportBySitePending || exportOosReportByCategoryPending || exportOosReportByOrderNumberPending
              || fetchOosAccountAccountTypePending || fetchOosAccountCustomerPending || fetchOosAccountOrderPending
              || exportOosAccountAccountTypePending || exportOosAccountCustomerPending || exportOosAccountOrderPending
              || fetchSummaryDataBySitePending || exportSummaryDataBySitePending
            }
            columns={renderTableColumns(tableColumnsWithCanada, tabKey, renderElementIndex)}
            dataSource={dataSource}
            pagination={false}
            onChange={onTableChange}
            scroll={{
              x: 'max-content',
              y: tabKey === 'Out & Subs' ? 320 : 170
            }}
            footer={renderFooter}
          />
          <div className="is-show-mobile">
            <div className="reports-mobile-list">
              <Spin spinning={fetchScInActionDataPending || fetchSummaryDataPending || fetchOrdersReportByChannelTypePending 
              || exportSummaryReportPending || exportOrdersReportByChannelTypePending || exportScInActionReportDataPending 
              || fetchSummaryCustomerDataPending || fetchSummaryOrderDataPending || exportSummaryCustomerReportPending || exportSummaryOrderReportPending 
              || fetchScInActionCustomerDataPending || fetchScInActionOrderDataPending || exportScInActionCustomerReportPending || exportScInActionOrderReportPending||
              fetchSummaryDataFromChannelTypePending || fetchOrdersDataPending || exportOrdersReportPending ||
              fetchOrderDetailReportPending || exportOrderDetailReportPending 
              || fetchSummaryDataByRegionPending || exportSummaryRegionReportPending
              || fetchOosReportBySitePending || fetchOosReportByCategoryPending || fetchOosReportByOrderNumberPending 
              || exportOosReportBySitePending || exportOosReportByCategoryPending || exportOosReportByOrderNumberPending
              || fetchOosAccountAccountTypePending || fetchOosAccountCustomerPending || fetchOosAccountOrderPending
              || exportOosAccountAccountTypePending || exportOosAccountCustomerPending || exportOosAccountOrderPending
              || fetchSummaryDataBySitePending || exportSummaryDataBySitePending
              }>
            <div className={!dataSource ? "reports-no-data":"none"}>
              <Empty />
            </div>
            {dataSource && dataSource.length >0 && dataSource.map((record,index) => {
              return (
                <ul key={`${tabKey}-${index}`}>
                  {
                    columnsProp.map((colItem,colIndex) => {
                      const title = t(colItem.title);
                      const dataIndex = colItem.dataIndex;
                      const value = record[dataIndex];
                      return (<li key={`${tabKey}-${dataIndex}-${colIndex}`}>
                        <span className="sub01">{title}</span>
                        <span className="sub02">
                        {renderMobileValue(value,dataIndex,record,colItem)}
                        </span>
                      </li>)
                    })
                  }
                </ul>
                );
            })}
            </Spin>
            </div>
          </div>
          <Pagination
            style={{ textAlign: 'center' }}
            className={'report-pagination'}
            showSizeChanger
            current={pagination.pageIndex}
            pageSize={pagination.pageSize}
            total={totals}
            pageSizeOptions={pagination.pageSizeOptions}
            onShowSizeChange={onPaginationChange}
            onChange={onPaginationChange}
          />
        </div>
      </div>
    </div>
  );
};

CommonPage.propTypes = {};
CommonPage.defaultProps = {};
